import React from "react";

import { ISimpleTeachingMaterial, IPortfolio } from "../../../state";
import Dropdown from "../../../atoms/Dropdown";
import DownloadButton from "../../../atoms/DownloadButton";
import ModalConfirm from "../../../molecules/ModalConfirm";
import PortfolioPreview from "../PortfolioPreview";
import { API_URL } from "../../../teacherStore";

import styles from "./Portfolio.module.scss";

export type Props = {
  calling: boolean;
  student: { id: number; class_id: number };
  temporaryToken: string | null;
  portfolio: IPortfolio | null;
  teaching_materials: ISimpleTeachingMaterial[];
  onTeachingMaterialChange: (id: number) => void;
  onDownloadFile: () => void;
  onClearTemporaryToken: () => void;
};

const Portfolio: React.FC<Props> = ({
  calling,
  portfolio,
  teaching_materials,
  student,
  temporaryToken,
  onTeachingMaterialChange,
  onDownloadFile,
  onClearTemporaryToken,
}) => {
  const [
    teachingMaterial,
    setTeachingMaterial,
  ] = React.useState<ISimpleTeachingMaterial>();

  const findOnePagePortfolioId =
    teachingMaterial?.lessons.find(
      lesson => lesson.one_page_portfolio_assessment_id !== null,
    )?.one_page_portfolio_assessment_id ?? null;

  return (
    <div className={styles.wrapper}>
      <Dropdown
        options={teaching_materials.map(material => ({
          value: material.id,
          label: `${material.name} ${material.title}`,
        }))}
        onChange={value => {
          onTeachingMaterialChange(value);
          setTeachingMaterial(
            teaching_materials.find(material => material.id === value),
          );
        }}
      />
      <p className={styles.dropdownNote}>選択してください</p>
      <div>
        <DownloadButton
          className="ms-auto"
          calling={calling || !portfolio}
          onClick={onDownloadFile}
        >
          振り返りシートをダウンロードする
        </DownloadButton>
        {temporaryToken && teachingMaterial && (
          <ModalConfirm
            onClose={onClearTemporaryToken}
            title="ダウンロードしますか？"
            buttons={[
              {
                title: "キャンセル",
                action: onClearTemporaryToken,
                type: "None",
              },
              {
                title: "ダウンロード",
                action: () => {
                  window.open(
                    `${API_URL}/teaching_materials/${teachingMaterial.id}/portfolio_pdf?class_id=${student.class_id}&student_id=${student.id}&temporary_token=${temporaryToken}`,
                    "_blank",
                  );
                  onClearTemporaryToken();
                },
                type: "Success",
              },
            ]}
          />
        )}
      </div>
      {teachingMaterial && (
        <div className={styles.portfolioWrapper}>
          <PortfolioPreview
            teachingMaterial={teachingMaterial}
            portfolio={portfolio ?? undefined}
            onePagePortfolioId={findOnePagePortfolioId}
          />
        </div>
      )}
    </div>
  );
};

export default Portfolio;
